/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { type ReactNode, useMemo } from 'react';

import { cssMap, jsx, type StrictXCSSProp, XCSSAllProperties } from '@atlaskit/css';

import { getGradientIndexByString } from './utils';

const CSS_VAR_GRADIENT = '--fallback-gradient-background-image-value';

const gradients = [
	'270deg, #DFE1E6 0%, #A5ADBA 100%',
	'270deg, #FFEBE6 0%, #FF8F73 100%',
	'270deg, #EAE6FF 0%, #C0B6F2 100%',
	'270deg, #DEEBFF 0%, #4C9AFF 100%',
	'270deg, #B3F5FF 0%, #79E2F2 100%',
	'270deg, #E3FCEF 0%, #79F2C0 100%',
	'270deg, #FFF0B3 0%, #FFC400 100%',
];

const styles = cssMap({
	container: {
		width: '100%',
		height: '100%',
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		overflow: 'hidden',
		backgroundImage: `linear-gradient(${CSS_VAR_GRADIENT})`,
	},
});

type Props = {
	stringToHash: string;
	xcss?: StrictXCSSProp<XCSSAllProperties, never>;
	children?: ReactNode;
};

export function FallbackGradient(props: Props) {
	const gradientIndex = useMemo(
		() => getGradientIndexByString(props.stringToHash),
		[props.stringToHash],
	);
	return (
		<div
			css={[styles.container]}
			className={props.xcss}
			style={
				{
					[CSS_VAR_GRADIENT]: `linear-gradient(${gradients[gradientIndex]})`,
				} as React.CSSProperties
			}
			data-testid="profile-header-image-default"
		>
			{props.children}
		</div>
	);
}
